class ServerError extends Error {
  constructor(error) {
    super(`Server Error: ${error.message}`);
    this.codes = error.codes;
  }
}

export default ServerError;
